import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ConfirmEmail from './pages/ConfirmEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ApprovalDashboard from './pages/ApprovalDashboard';
import ApprovalDetails from './pages/ApprovalDetails';
import ExpenseDetails from './pages/ExpenseDetails';
import RequestApproval from './pages/RequestApproval';
import BudgetCommitment from './pages/BudgetCommitment';
import ExpenseReport from './pages/ExpenseReport';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/confirm-email" element={<ConfirmEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <ExpenseReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/budget-approval"
              element={
                <ProtectedRoute>
                  <ApprovalDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/approval/:id"
              element={
                <ProtectedRoute>
                  <ApprovalDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/expense/:id"
              element={
                <ProtectedRoute>
                  <ExpenseDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/request"
              element={
                <ProtectedRoute>
                  <RequestApproval />
                </ProtectedRoute>
              }
            />
            <Route
              path="/budget-commitment"
              element={
                <ProtectedRoute>
                  <BudgetCommitment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/expense-report"
              element={
                <ProtectedRoute>
                  <ExpenseReport />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
